import React, { useEffect } from 'react';
import { debounce } from 'lodash';
import { SoundDownloadContextConsumer } from '../../context/sounddownload';
import { Button, SoundDownloadManager } from '../..';
import { MAGNIFY_SVG, PLUS_SVG } from '../../assets';
import { translations } from '../../translations';
function SoundListHeader(props) {
    var total = props.paging ? props.paging.total : props.sounds ? props.sounds.length : 0;
    var _a = React.useState(props.search || ''), input = _a[0], setInput = _a[1];
    var title = props.title, onFilterChange = props.onFilterChange;
    var throttlePropsUpdate = React.useCallback(debounce(function (value) {
        onFilterChange && onFilterChange({ search: value });
    }, 250), []);
    useEffect(function () {
        setInput(props.search || '');
    }, [props.search]);
    return React.createElement("div", { className: "SoundListHeader" },
        React.createElement("div", { className: "header" },
            React.createElement(SoundDownloadContextConsumer, null, function (value) {
                return React.createElement("div", { className: "header-left" },
                    React.createElement("span", { className: "title" }, title || translations.Sounds),
                    React.createElement("span", { className: 'info' },
                        React.createElement("span", { className: "total-sounds" }, total),
                        total === 1
                            ? translations.Sound
                            : translations.Sounds),
                    value.length > 0 &&
                        React.createElement("div", { className: 'info link', onClick: function () { props.onSoundDownloadMulti(value); } },
                            "Download ",
                            React.createElement("span", { className: "total-sounds selected" }, value.length),
                            "Selected Samples",
                            React.createElement(Button, { className: "clear-selected-btn", buttonText: 'Clear Selected', variation: 'tagTiny', border: true, onClick: function () {
                                    SoundDownloadManager.getInstance().clear();
                                }, fontSize: '1.3rem' })),
                    React.createElement("span", null, props.leftHeaderActionRenderer ? (typeof props.leftHeaderActionRenderer === 'function' ? props.leftHeaderActionRenderer() : props.leftHeaderActionRenderer) : null));
            }),
            React.createElement("div", { className: "header-right" }, onFilterChange && React.createElement("div", { className: 'form' },
                React.createElement("img", { className: "magnify-icon no-select", src: MAGNIFY_SVG, alt: "" }),
                React.createElement("input", { className: "search-bar", name: "input", type: "search", onChange: function (e) {
                        setInput(e.currentTarget.value);
                        throttlePropsUpdate(e.currentTarget.value);
                    }, placeholder: "Refine Search", value: input }),
                React.createElement("img", { className: "cancel-grey " + (input !== '' ? '' : 'hidden'), src: PLUS_SVG, onClick: function () {
                        setInput('');
                        onFilterChange({ search: '' });
                    }, alt: "cancel" })))));
}
export default SoundListHeader;
//# sourceMappingURL=SoundsListHeader.js.map